module.exports = __webpack_public_path__ + "img/expansion_draft_logo.ea0b17e6.png";